/**
 * Uses Swiper package to create a carousel for product media
 * More info: https://swiperjs.com/
 */
class bundleProductCarousel extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      slider: '[bundle-product-carousel]',
    };
    
    this.settings = {
      elements: {
        slider: this.querySelector(this.selectors.slider),
      },
      instances: {
        slider: null,
      },
      options: {
        slider: {
          initialSlide: 0,
          slidesPerView: 2.8,
          spaceBetween: 10,
          centerInsufficientSlides: true,
          navigation: {
            prevEl: this.querySelector('.swiper-button-prev'),
            nextEl: this.querySelector('.swiper-button-next'),
          }
        },
      },
    };
  }

  connectedCallback() {
    this.init();

    document.addEventListener('alexa:start-mobile-zoom', event => {
      this.settings.instances.slider.allowTouchMove = false;
    });

    document.addEventListener('alexa:end-mobile-zoom', event => {
      this.settings.instances.slider.allowTouchMove = true;
    });
  }

  init() {
    if (!this.settings.elements.slider)
      return;
    this.settings.instances.slider = new Swiper(
      this.settings.elements.slider,
      this.settings.options.slider,
    );
  }
}

customElements.define('bundle-product-carousel', bundleProductCarousel);
